import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import SearchBox from "../search-box";
import NewsCard from "../events/events-card";
import ReactPaginate from "react-paginate";
import Api from '../../../lib/seam-api';
import CustomSelect from '../select';
import NoResults from '../no-results';
import {fireEnquireOpenEvent} from "../../overlay/enquire";

class News extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search : '',
            items : [],
            page: 1,
            pageCount : 0,
            cdnUrl : '/images',
            direction : 'desc'
        };

        this.searchCanceler = null;
    }

    onChangeHandler({target: { value }}) {
        this.setState({
            search : value
        }, () => this.changed());
    }

    componentDidMount() {
        this.fetchItems();
    }

    changed() {
        if(this.state.search.length >= 1) {
            return this.search();
        }

        this.fetchItems();
    }

    search() {

        if(this.searchTimeOut) {
            clearTimeout(this.searchTimeOut);

        }
        if(this.searchCanceler !== null) {
            this.searchCanceler.cancel('Cancel Content Search');
            this.searchCanceler = null;
        }

        this.searchTimeOut = setTimeout(() => {
            Api.content().search(this.state.search, [16], [], searchCanceler => {
                this.searchCanceler = searchCanceler;
            }).then(response => {
                this.setState({
                    items : response.data,
                    pageCount : 0,
                    page : 1,
                    cdnUrl : response.meta.cdn_url
                })
            });
        }, 200);

    }

    fetchItems(page = this.state.page) {
        Api.content().list(page, 10, [16], [], 'published', this.state.direction).then(response => {
            this.setState({
                items : response.data,
                pageCount : response.meta.last_page,
                cdnUrl : response.meta.cdn_url
            });
        })
    }

    handlePageClick(event) {
        this.setState({ page: event.selected + 1 }, () => this.fetchItems());

    }

    truncateDescription (input) {

        return input?.length > 65 ? `${input.substring(0, 65)}...` : input;

    }

    render() {
        return (
            <>
                <div className="index__topbar">
                    <SearchBox search={this.state.search} onChangeHandler={this.onChangeHandler.bind(this)}/>

                        <div className="utils__row index-topbar__wrap">
                            <CustomSelect placeholder="Sort results by" onChange={(e) => this.setState({ direction: e.value }, () => this.changed())} items={[
                                {
                                    option: 'Date Ascending',
                                    value: 'asc'
                                },
                                {
                                    option: 'Date Descending',
                                    value: 'desc'
                                },
                                {
                                    option: 'By Catagory (Asc)',
                                    value: 'catagory-asc'
                                },
                                {
                                    option: 'By Catagory (Desc)',
                                    value: 'catagory-desc'
                                }
                            ]}/>
                        </div>
                </div>

                { this.state.items.length > 0 ? <>
                    <div className="news__items">
                        { this.state.items.map(item => {
                            return(
                                    <NewsCard
                                        data={{
                                            name: item.title,
                                            description: this.truncateDescription(item.meta?.preview_description),
                                            start:  item.published,
                                            slug : `/news/${item.slug.replace('news/', '')}`,
                                            background : item.meta ? `${this.state.cdnUrl}/images/${item.meta?.preview_image}` : ''
                                        }}
                                    />
                                );
                            })
                        }
                    </div>

                    <ReactPaginate
                        breakLabel="..."
                        onPageChange={this.handlePageClick.bind(this)}
                        pageRangeDisplayed={5}
                        pageCount={this.state.pageCount}
                        nextLabel={<img src='/images/blocks/gallery/arrow.svg' alt='Next Arrow'/>}
                        previousLabel={<img src='/images/blocks/gallery/arrow.svg' alt='Previous Arrow'/>}
                        renderOnZeroPageCount={null}
                        containerClassName="event-index__pagination"
                    />
                </> : <NoResults
                    title={'NO NEWS FOUND'}
                    subtitle={'Please can you refine your search result or try searching manually.'}
                    content={`Need help finding what you're looking for?`}
                    onClick={e => {
                        e.preventDefault();
                        fireEnquireOpenEvent(0)
                    }}
                />
                }
            </>
        );
    }
}

export default News;


const el = document.getElementById('news-index-component');

if(el)  {
    ReactDOM.render(<News />, el);
}
